import * as React from 'react'
import styled from 'styled-components'
import { IconButton, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'i18n'
import TwitterIcon from '@material-ui/icons/Twitter'
import WebpImg from 'components/Image/WebpImg'

const Component = () => {
  const { t } = useTranslation('components')
  const s = useStyle({})

  return (
    <Footer>
      <Grid container className={s.container}>
        <Grid item xs={12} sm={3} className={s.logo}>
          <LogoWebpImg
            webpSrc="/static/images/logo_letter.webp"
            imgSrc="/static/images/logo_letter.png"
            imgProps={{ alt: 'utoniq' }}
          />
        </Grid>
        <Grid item xs={12} sm={3} className={s.company}>
          <Title>{t('Footer.Info.aboutUs')}</Title>
          <ul style={{ paddingTop: 20, listStyleType: 'none' }}>
            <List>
              <Link href="//about.utoniq.com">
                {t('Footer.Info.companyInfo')}
              </Link>
            </List>
            <List>
              <Link href="//about.utoniq.com/product">
                {t('Footer.Info.product')}
              </Link>
            </List>
            <List>
              <Link href="//about.utoniq.com/recruit">
                {t('Footer.Info.employmentInfo')}
              </Link>
            </List>
          </ul>
        </Grid>
        <Grid item xs={12} sm={3} className={s.service}>
          <Title>{t('Footer.Info.serviceRelated')}</Title>
          <ul style={{ paddingTop: 20, listStyleType: 'none' }}>
            <List>
              <Link href="//tayori.com/faq/2782b7ea9a2540b85dd4d579cbd98d58c09c6c81">
                {t('Footer.Info.serviceGuide')}
              </Link>
            </List>
            <List>
              <Link href="//about.utoniq.com/p-term/">
                {t('Footer.Info.termsOfService')}
              </Link>
            </List>
            <List>
              <Link href="//about.utoniq.com/artist-term/">
                {t('Footer.Info.termsOfServiceForArtist')}
              </Link>
            </List>
            <List>
              <Link href="//about.utoniq.com/privacy/">
                {t('Footer.Info.privacyPolicy')}
              </Link>
            </List>
            <List>
              <Link href="//about.utoniq.com/scl/">
                {t('Footer.Info.specifiedCommercialTransactionLaw')}
              </Link>
            </List>
          </ul>
        </Grid>
        <Grid item xs={12} sm={3} className={s.sns}>
          <Title>SNS</Title>
          <div style={{ paddingTop: 20 }}>
            <IconButton
              href="//twitter.com/utoniq_info"
              style={{ backgroundColor: '#2F2F2F' }}
            >
              <TwitterIcon style={{ color: 'white' }} />
            </IconButton>
          </div>
        </Grid>
      </Grid>
      <Copyright>&copy;2019 Utoniq</Copyright>
    </Footer>
  )
}

export default Component

const Copyright = styled.div({
  color: '#A9A9A9',
  textAlign: 'right',
  fontSize: 14,
})

const List = styled.li({
  padding: '5px 0',
})

const Link = styled.a({
  color: 'white',
  fontSize: 18,
  textDecoration: 'none',
})

const Footer = styled.footer({
  padding: '80px 40px 20px 40px',
  minHeight: 430,
  backgroundColor: '#424242',
})

const Title = styled.h3({
  color: '#A9A9A9',
  fontSize: 14,
})

const LogoWebpImg = styled(WebpImg)`
  width: 126px;
`

const useStyle = makeStyles(({ breakpoints: b }) => ({
  container: {
    padding: '0 0 20px 0',
    // [b.down('xs')]: {
    //   textAlign: 'center'
    // },
  },
  logo: {
    margin: '0 auto',
  },
  company: {
    margin: '0 0 40px 0',
  },
  service: {
    margin: '0 0 40px 0',
  },
  sns: {},
}))
